import { SimpleFieldComponent } from "../simpleField/simple-field-component"
import { validateSingleInputField } from "../../validation/api"


export class SimpleValidatedFieldComponent {
    private readonly fieldComponent: SimpleFieldComponent

    constructor(documentObject: Document, inputField: string, private readonly validateImmediately: boolean, private readonly fieldType: string) {
        this.fieldComponent = new SimpleFieldComponent(documentObject, inputField, validateImmediately)
        this.fieldComponent.registerEventListeners(() => this.validate())
    }

    async validate(): Promise<void> {
        try {
            const validationResult = await validateSingleInputField({ type: this.fieldType, value: this.fieldComponent.value })
            this.fieldComponent.setValidationResult(validationResult)
        } catch (e) {
            this.fieldComponent.clearErrors();
        }
    }
}
